import React from 'react'
import { AppBar, Container, Toolbar, Typography, IconButton, Divider, Drawer, List, makeStyles, Grid } from '@material-ui/core'
import { Menu, Clear } from '@material-ui/icons'
import MaterialMenu from '@material-ui/core/Menu'
import MaterialButton from '@material-ui/core/Button'
import MaterialMenuitem from '@material-ui/core/MenuItem'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { Link, unstable_collectionGraphql } from 'gatsby'
import Styles from './nav.module.scss'
// import LinkButton from './LinkButton'
import clsx from 'clsx'
// import LinkButton from '../components/linkButton'

const remodelmateLogo = "https://remodelmate-v2-local.s3.us-east-2.amazonaws.com/branding/logos/wordmark/svg/remodelmate-black.svg"
const drawerWidth = '100%'
const drawerHeight = '50%'

const useStyles = makeStyles(theme => ({
    root: {
      display: 'flex',
    },
    appBar: {
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    appBarShift: {
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginRight: drawerWidth,
    },
    title: {
      flexGrow: 1,
    },
    hide: {
      display: 'none',
    },
    drawer: {
      width: drawerWidth,
      height: drawerHeight,
      flexShrink: 0,
    },
    drawerPaper: {
      width: '100%',
      height: 'unset',
      marginLeft: "0 !important",
    },
    drawerHeader: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(0, 1),
      ...theme.mixins.toolbar,
      justifyContent: 'flex-start',
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      marginRight: -drawerWidth,
    },
    contentShift: {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginRight: 0,
    },
    menuIcon: {
      color: '1B2230'
    }
  }))

  export default function MainNav({ user, loading }) {
    const classes = useStyles()
    const [open, setOpen] = React.useState(false)
  
    const handleDrawerOpen = () => {
      setOpen(true)
    }
  
    const handleDrawerClose = () => {
      setOpen(false)
    }

    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

  
    return (
        <div className={classes.root}>
            <AppBar
                position="fixed"
                className={Styles.navMods}
            >
                <Container>
                    <Toolbar className={Styles.toolBar}>
                        <Typography style={{ flex: 1 }}>
                            <a
                                href="https://remodelmate.com"
                            >
                                <img
                                    src={remodelmateLogo}
                                    alt="remodelmate-logo"
                                    className={Styles.brand}
                                />
                            </a>
                        </Typography>
                        
                        <Link
                            style={{ textDecoration: "none" }}
                            to="https://remodelmate.com/"
                        >
                            <button
                                className={Styles.linkButtonNoFill}
                            >
                                Homeowners
                            </button>
                        </Link>

                        <Link
                            style={{ textDecoration: "none" }}
                            to="https://remodelmate.com/contractors"
                        >
                            <button
                                className={Styles.linkButtonNoFill}
                            >
                                Contractors
                            </button>
                        </Link>

                        <MaterialButton
                            aria-controls="simple-menu"
                            aria-haspopup="true"
                            onClick={handleClick}
                            className={Styles.linkButtonMore}
                        >
                            More
                            <ExpandMoreIcon />
                        </MaterialButton>
                        <MaterialMenu
                            id="simple-menu"
                            anchorEl={anchorEl}
                            keepMounted
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                            className={Styles.linkButtonMoreMenu}
                        >
                            <MaterialMenuitem
                                component="a"
                                href="https://blog.remodelmate.com"
                                className={Styles.linkButtonMoreItem}
                            >
                              Blog
                            </MaterialMenuitem>
                            <MaterialMenuitem
                                component="a"
                                href="https://remodelmate.com/about"
                                className={Styles.linkButtonMoreItem}
                            >
                              About Us
                            </MaterialMenuitem>
                        </MaterialMenu>


                <Link
                    style={{ textDecoration: "none" }}
                    to="https://remodelmate.com/homeowners/login"
                >
                    <button
                        className={Styles.linkButtonUnderline}
                    >
                        Login
                    </button>
                </Link>

                <Link
                    style={{ textDecoration: "none" }}
                    to="https://remodelmate.com/estimate/1"
                >
                    <button
                        className={Styles.linkButtonFill}
                    >
                        Start Now
                    </button>
                </Link>
    
                <IconButton
                    aria-label="open drawer"
                    edge="end"
                    onClick={handleDrawerOpen}
                    className={`${clsx(open && classes.hide)} ${Styles.hamburger}`}
                >
                    <Menu style={{ color: "1B2230" }} />
                    <span style={{ fontSize: "1rem", color: "#1B2230" }}>
                    <b>Menu</b>
                    </span>
                </IconButton>
                </Toolbar>
          </Container>
        </AppBar>
  
        <Toolbar className={Styles.dummyToolBar} />
  
        {/* Start of Mobile Nav */}
        <Drawer
          type="temporary"
          anchor="right"
          open={open}
          classes={{ paper: classes.drawerPaper }}
        >
          <Container>
            <Toolbar className={Styles.toolbarDrawer}>
              <Typography style={{ flex: 1 }}>
                <a
                  href="https://remodelmate.com"
                >
                  <img
                    src={remodelmateLogo}
                    alt="remodelmate-logo"
                    className={Styles.brand}
                  />
                </a>
              </Typography>
              
              <IconButton
                aria-label="close drawer"
                edge="end"
                onClick={handleDrawerClose}
              >
                <Clear style={{ fill: "#1B2230", height: "1rem", width: "auto" }} />
                <span style={{ fontSize: "1rem", color: "#1B2230"}}>
                  <b>Close</b>
                </span>
              </IconButton>

            </Toolbar>

          </Container>
  
          <Divider />

          <Container>
            <List style={{ paddingTop: "1rem" }}>

              <Link
                to="https://remodelmate.com/"
                style={{ textDecoration: "none" }}
              >
                <button
                  className={Styles.mobileNavButton}
                >
                  Homeowners
                </button>
              </Link>

              <Link
                to="https://remodelmate.com/contractors"
                style={{ textDecoration: "none" }}
              >
                <button
                  className={Styles.mobileNavButton}
                >
                  Contractors
                </button>
              </Link>

              <Link
                to="https://blog.remodelmate.com"
                style={{ textDecoration: "none" }}
              >
                <button
                  className={Styles.mobileNavButton}
                >
                  Blog
                </button>
              </Link>

              <Link
                to="https://remodelmate.com/about"
                style={{ textDecoration: "none" }}
              >
                <button
                  className={Styles.mobileNavButton}
                >
                  About
                </button>
              </Link>

              <Link
                to="https://remodelmate.com/faq"
                style={{ textDecoration: "none" }}
              >
                <button
                  className={Styles.mobileNavButton}
                >
                  Homeowners FAQ
                </button>
              </Link>

              <Link
                to="https://remodelmate.com/contractors/faq"
                style={{ textDecoration: "none" }}
              >
                <button
                  className={Styles.mobileNavButton}
                >
                  Contractors FAQ
                </button>
              </Link>

              <Link
                to="https://angel.co/company/remodelmate/jobs"
                style={{ textDecoration: "none" }}
              >
                <button
                  className={Styles.mobileNavButton}
                >
                  Careers
                </button>
              </Link>

              <Divider />

              <Grid container alignItems="center" justify="center" className={Styles.mobileGridContainer}>
                <Grid item xs={6} sm={6}>
                  <div>
                    <Link
                      to="https://remodelmate.com/homeowners/login"
                      style={{ textDecoration: "none" }}
                    >
                      <button
                        className={Styles.mobileNavButtonLogin}
                      >
                        Log In
                      </button>
                    </Link>
                  </div>
                </Grid>
                <Grid item xs={6} sm={6}>
                  <div>
                    <Link
                      to="https://remodelmate.com/estimate/1"
                      style={{ textDecoration: "none" }}
                    >
                      <button
                        className={Styles.mobileNavButtonGetEstimate}
                      >
                        Get Estimate
                      </button>
                    </Link>
                  </div>
                </Grid>
              </Grid>

            </List>
          </Container>
        </Drawer>
      </div>
    )
  }